/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { TrackplanningSVGDto } from '../model/trackplanningSVGDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class PlanningRestService {
  protected basePath = 'http://app.exatrek.de';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Planning
   * @param fieldId Id of field
   * @param areaCostCoefficient Use on Divide: set Coefficient for Area
   * @param circuitTurnsMinimumAngle Circuit Turn Minimal Angle
   * @param fullConcaveTurns should turns consist of 2 backwards drives for full coverage or not for time
   * @param internalPattern Pattern SAP or SFP3/5/7
   * @param maxHeadlandCircuits Max Headland Circuits in N
   * @param patternStart Start/End-NearEntrance
   * @param planningOptimization check for best settings
   * @param planningOptimization2 define field entrance
   * @param planningOptimization3 define excluded areas
   * @param subdivide should the field be divided in subfields
   * @param thresholdCollinearAngle Use on Divide:
   * @param thresholdRightAngle Use on Divide:
   * @param timeCostCoefficient Use on Divide: set Coefficient for Time
   * @param turnOffset Turn-Offset in m
   * @param turningRadius Minimum Turning Radius in m
   * @param turningSpeedPercentage Turning-Speed in Percentage (50 for half)
   * @param workingAngleDegree Working Angle in 0°-180° (0° Horizontal, positiv counterclockwise) if not specified OPTIMAL will be used
   * @param workingSpeed Working speed in m/s
   * @param workingWidth Working width in m
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTrackplanningForFieldUsingGET(
    fieldId: number,
    areaCostCoefficient?: number,
    circuitTurnsMinimumAngle?: number,
    fullConcaveTurns?: boolean,
    internalPattern?: string,
    maxHeadlandCircuits?: number,
    patternStart?: string,
    planningOptimization?: boolean,
    planningOptimization2?: string,
    planningOptimization3?: string,
    subdivide?: boolean,
    thresholdCollinearAngle?: number,
    thresholdRightAngle?: number,
    timeCostCoefficient?: number,
    turnOffset?: number,
    turningRadius?: number,
    turningSpeedPercentage?: number,
    workingAngleDegree?: number,
    workingSpeed?: number,
    workingWidth?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*' | 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<TrackplanningSVGDto>;
  public getTrackplanningForFieldUsingGET(
    fieldId: number,
    areaCostCoefficient?: number,
    circuitTurnsMinimumAngle?: number,
    fullConcaveTurns?: boolean,
    internalPattern?: string,
    maxHeadlandCircuits?: number,
    patternStart?: string,
    planningOptimization?: boolean,
    planningOptimization2?: string,
    planningOptimization3?: string,
    subdivide?: boolean,
    thresholdCollinearAngle?: number,
    thresholdRightAngle?: number,
    timeCostCoefficient?: number,
    turnOffset?: number,
    turningRadius?: number,
    turningSpeedPercentage?: number,
    workingAngleDegree?: number,
    workingSpeed?: number,
    workingWidth?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*' | 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<TrackplanningSVGDto>>;
  public getTrackplanningForFieldUsingGET(
    fieldId: number,
    areaCostCoefficient?: number,
    circuitTurnsMinimumAngle?: number,
    fullConcaveTurns?: boolean,
    internalPattern?: string,
    maxHeadlandCircuits?: number,
    patternStart?: string,
    planningOptimization?: boolean,
    planningOptimization2?: string,
    planningOptimization3?: string,
    subdivide?: boolean,
    thresholdCollinearAngle?: number,
    thresholdRightAngle?: number,
    timeCostCoefficient?: number,
    turnOffset?: number,
    turningRadius?: number,
    turningSpeedPercentage?: number,
    workingAngleDegree?: number,
    workingSpeed?: number,
    workingWidth?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*' | 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<TrackplanningSVGDto>>;
  public getTrackplanningForFieldUsingGET(
    fieldId: number,
    areaCostCoefficient?: number,
    circuitTurnsMinimumAngle?: number,
    fullConcaveTurns?: boolean,
    internalPattern?: string,
    maxHeadlandCircuits?: number,
    patternStart?: string,
    planningOptimization?: boolean,
    planningOptimization2?: string,
    planningOptimization3?: string,
    subdivide?: boolean,
    thresholdCollinearAngle?: number,
    thresholdRightAngle?: number,
    timeCostCoefficient?: number,
    turnOffset?: number,
    turningRadius?: number,
    turningSpeedPercentage?: number,
    workingAngleDegree?: number,
    workingSpeed?: number,
    workingWidth?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*' | 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    if (fieldId === null || fieldId === undefined) {
      throw new Error('Required parameter fieldId was null or undefined when calling getTrackplanningForFieldUsingGET.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (areaCostCoefficient !== undefined && areaCostCoefficient !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areaCostCoefficient, 'areaCostCoefficient');
    }
    if (circuitTurnsMinimumAngle !== undefined && circuitTurnsMinimumAngle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>circuitTurnsMinimumAngle, 'circuitTurnsMinimumAngle');
    }
    if (fullConcaveTurns !== undefined && fullConcaveTurns !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fullConcaveTurns, 'fullConcaveTurns');
    }
    if (internalPattern !== undefined && internalPattern !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>internalPattern, 'internalPattern');
    }
    if (maxHeadlandCircuits !== undefined && maxHeadlandCircuits !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxHeadlandCircuits, 'maxHeadlandCircuits');
    }
    if (patternStart !== undefined && patternStart !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>patternStart, 'patternStart');
    }
    if (planningOptimization !== undefined && planningOptimization !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>planningOptimization, 'planningOptimization');
    }
    if (planningOptimization2 !== undefined && planningOptimization2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>planningOptimization2, 'planningOptimization');
    }
    if (planningOptimization3 !== undefined && planningOptimization3 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>planningOptimization3, 'planningOptimization');
    }
    if (subdivide !== undefined && subdivide !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subdivide, 'subdivide');
    }
    if (thresholdCollinearAngle !== undefined && thresholdCollinearAngle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>thresholdCollinearAngle, 'thresholdCollinearAngle');
    }
    if (thresholdRightAngle !== undefined && thresholdRightAngle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>thresholdRightAngle, 'thresholdRightAngle');
    }
    if (timeCostCoefficient !== undefined && timeCostCoefficient !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>timeCostCoefficient, 'timeCostCoefficient');
    }
    if (turnOffset !== undefined && turnOffset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>turnOffset, 'turnOffset');
    }
    if (turningRadius !== undefined && turningRadius !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>turningRadius, 'turningRadius');
    }
    if (turningSpeedPercentage !== undefined && turningSpeedPercentage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>turningSpeedPercentage, 'turningSpeedPercentage');
    }
    if (workingAngleDegree !== undefined && workingAngleDegree !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workingAngleDegree, 'workingAngleDegree');
    }
    if (workingSpeed !== undefined && workingSpeed !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workingSpeed, 'workingSpeed');
    }
    if (workingWidth !== undefined && workingWidth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workingWidth, 'workingWidth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (apiKey) required
    localVarCredential = this.configuration.lookupCredential('apiKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['*/*', 'application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/v3/planning/path/${this.configuration.encodeParam({ name: 'fieldId', value: fieldId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    return this.httpClient.request<TrackplanningSVGDto>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
